import * as PIXI from 'pixi.js'
import DataManager from '../data/DataManager'

/**
 * PIXI.Application共通化クラス
 */
class MyApplication {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //シングルトンインスタンス
  private static _app: PIXI.Application

  //アプリケーション
  // private _app: PIXI.Application

  // ---------------------------------------------------------------------------------------------------------
  // --	MyApplication
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  private constructor() {}

  /** インスタンスの取得 */
  public static get app(): PIXI.Application {
    if (!this._app) {
      this._app = new PIXI.Application({
        resolution: 1,
        antialias: false,
      })

      //FPSの最大値を設定
      this._app.ticker.maxFPS = 60

      //zIndexで重ね順を変更できるようにする
      this._app.stage.sortableChildren = true

      //DOMを配置
      // @ts-expect-error
      document.getElementById('canvas-container').appendChild(this._app.view)
    }

    // 生成済みのインスタンスを返す
    return this._app
  }

  /**
   * リサイズ
   */
  public static resize() {
    //コンフィグファイル
    const config: any = DataManager.instance.getData('config')

    //コンテナDOM参照
    const container: HTMLElement = document.getElementById('canvas-container')

    //計算
    const wW = container.clientWidth
    const wH = container.clientHeight
    const rate = wW / config.STAGE_WIDTH

    //リサイズ
    this._app.renderer.resize(config.STAGE_WIDTH, wH / rate)
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default MyApplication
